module.exports = __webpack_public_path__ + "assets/img/ic-arrow-right-r.d9ce9046.svg";